<script>
  import { afterUpdate, beforeUpdate, onMount } from "svelte"

  //export let country = { id: "us", name: "US" }

  let countries = [
    { id: "us", name: "US" },
    { id: "tw", name: "Taiwan" },
    { id: "cn", name: "China" },
    { id: "de", name: "German" },
    { id: "fr", name: "France" },
    { id: "jp", name: "Japan" },
  ]
  let selectedCountry = {}

  const apiKEY = "15fab766c2814dcd91a17e7b4794d136"
  let dataUrl = ""
  let items = []
  let pm
  let promise = Promise.resolve([])

  // $: dataUrl = `https://newsapi.org/v2/top-headlines?country=${selectedCountry.id}&sortBy=publishedAt&apiKey=${apiKEY}`

  function showNews(c) {
    selectedCountry = c
    // dataUrl = `https://newsapi.org/v2/top-headlines?country=${selectedCountry.id}&category=technology&pageSize=10&sortBy=publishedAt&apiKey=${apiKEY}`
    dataUrl = `https://newsapi.org/v2/top-headlines?country=${selectedCountry.id}&pageSize=10&sortBy=publishedAt&apiKey=${apiKEY}`

    //  console.log("Selected country: " + selectedCountry.name)

    promise = fetchData()
  }

  async function fetchData() {
    const response = await fetch(dataUrl)
    const data = await response.json()
    //console.log(data)
    items = data["articles"]
    //console.log(typeof data)
    //console.log(typeof items)
    //console.log(items)
  }

  // const fetchData = async () => {
  //   dataUrl = `https://newsapi.org/v2/top-headlines?country=${selectedCountry.id}&sortBy=publishedAt&apiKey=${apiKEY}`
  //   const response = await fetch(dataUrl)
  //   const data = await response.json()
  //   //console.log(data)
  //   items = data["articles"]
  //   //console.log(typeof data)
  //   //console.log(typeof items)
  //   console.log(items)
  // }

  //fetchData()
  //console.log(items.length)
  //onMount(fetchData())
  //afterUpdate(fetchData())
</script>

<main>
  <a href="/sandbox">Return to Sandbox</a>
  <div class="container">
    <!-- <div style="display:none;">{fetchData()}</div> -->

    <h5>World Headline News</h5>
    <!-- <p>Total news items: {items.length}</p> -->
    <div class="card">
      <!-- <div class="card-body"> -->
      {#each countries as thisCountry}
        <a
          class="waves-effect waves-light orange darken-2 btn"
          on:click={() => showNews(thisCountry)}>{thisCountry.name} News</a
        >
      {/each}
      <!-- </div> -->
    </div>

    {#each items as item}
      <div class="card">
        <img src={item.urlToImage} alt="Some picture" />
        <div class="card-body">
          <h5>{item.title}</h5>
          <p>{item.description}</p>
          <a href={item.url}>Read</a>
        </div>
      </div>
    {:else}
      <div class="orange-text darken-4 card-body">
        <h5>Please click a News button above...</h5>
      </div>
    {/each}
  </div>
</main>

<style>
  h1 {
    color: purple;
    font-family: "kalam";
  }
  .container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(305px, 1fr));
    grid-gap: 15px;
  }
  .container > .card img {
    max-width: 100%;
    max-height: 120px;
  }
  .container a {
    margin: 5px;
  }
</style>
